import {billingService} from 'services';

export const SUBSCRIBE_BEGIN = 'billing/SUBSCRIBE_BEGIN';
export const SUBSCRIBE_SUCCESS = 'billing/SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_ERROR = 'billing/SUBSCRIBE_ERROR';

export const UNSUBSCRIBE_BEGIN = 'billing/UNSUBSCRIBE_BEGIN';
export const UNSUBSCRIBE_SUCCESS = 'billing/UNSUBSCRIBE_SUCCESS';
export const UNSUBSCRIBE_ERROR = 'billing/UNSUBSCRIBE_ERROR';

export function subscribeBegin(){
    return {
        type: SUBSCRIBE_BEGIN
    }
}

export function subscribeSuccess(confirmation_url){
    return {
        type: SUBSCRIBE_SUCCESS,
        confirmation_url: confirmation_url

    }
}

export function subscribeError(error){
    return {
        type: SUBSCRIBE_ERROR,
        error: error
    }
}

export function unsubscribeBegin(){
    return {
        type: UNSUBSCRIBE_BEGIN
    }
}

export function unsubscribeSuccess(){
    return {
        type: UNSUBSCRIBE_SUCCESS
    }
}

export function unsubscribeError(){
    return {
        type: SUBSCRIBE_ERROR
    }
}

export function buyCredits(){
    return (dispatch)=>{
        billingService().buyCredits().then((res)=>{
            window.location.href = res.data.confirmation_url; 
        }).catch((err)=>{
        });
    }
}
export function subscribe(plan){
    return (dispatch)=>{
        dispatch(subscribeBegin());
        billingService().subscribe(plan).then((res)=>{
            window.location.href = res.data.confirmation_url; 
            dispatch(subscribeSuccess());
        }).catch((err)=>{
            dispatch(subscribeError(err));
        });
    }
}

export function installTheme(theme){
    return (dispatch)=>{
        if (theme.themes && Array.isArray(theme.themes)) {
            billingService().installThemes(theme.themes, theme.config).then((res)=>{
                window.location.href = '/templates';
            }).catch((err)=>{
            });
        } else {
            billingService().installTheme(theme).then((res)=>{
                window.location.href = '/templates';
            }).catch((err)=>{
            });
        }
    }
}


export function unsubscribe(){
    return (dispatch)=>{
        dispatch(unsubscribeBegin());
        billingService().unsubscribe().then((res)=>{
            window.location.reload();
            dispatch(unsubscribeSuccess());
        }).catch((err)=>{
            dispatch(unsubscribeError(err));
        });
    }
}

export function dismissReview(resetCounter){
    return ()=>{
        billingService().dismissReview(resetCounter).catch(()=>{});
    }
}

const reducer = (state = {
}, action={}) => {
  switch(action.type){
    // case FETCH_ACCOUNT_BEGIN:
    //     return {
    //         ...state,
    //         fetching: true,
    //     };
    // case FETCH_ACCOUNT_SUCCESS:
    //     return {
    //         ...state,
    //         fetching: false,
    //         ...action.account
    //     };
    // case FETCH_ACCOUNT_ERROR:
    //     return {
    //         ...state,
    //         fetching: false,
    //         error: action.error
    //     };
    default:
        return state;
  }
}

export default reducer;


// WEBPACK FOOTER //
// app/modules/billing.js